module.exports = __webpack_public_path__ + "static/media/mage_head.e07b9913.svg";